'use client'

import { Button } from '@/components/ui/Button'
import { Layout } from '@/components/ui/Layout'
import { useArtistRouter } from '@/hooks/useArtistRouter'
import { useRouter } from 'next/navigation'
import React from 'react'

export default function NotFound() {
  const router = useRouter()
  const { goArtistLastMainPage } = useArtistRouter()

  const handleGoBack = () => {
    router.back()
  }

  const handleGoHome = () => {
    goArtistLastMainPage()
  }

  return (
    <Layout>
      <div className="w-full h-full flex flex-col justify-center items-center relative">
        <div className="flex flex-col justify-center items-center gap-[16px]">
          <img src="/img/payment/failed.svg" />
          <p className="text-h300 text-center">찾을 수 없는 페이지</p>
          <div className="flex flex-col justify-center items-center gap-[6px]">
            <p className="text-center text-body3">
              요청하신 페이지를 찾을 수 없어요.
              <br />
              서비스 이용에 불편을 드려 죄송합니다.
            </p>
          </div>
        </div>
        <div className="flex w-full p-[20px] gap-[8px] absolute bottom-0 left-0">
          <Button onClick={handleGoBack} size="large" fullWidth color="secondary">
            뒤로가기
          </Button>
          <Button onClick={handleGoHome} size="large" fullWidth color="primary">
            홈 바로가기
          </Button>
        </div>
      </div>
    </Layout>
  )
}
